import { call, cancelled, fork, put, select, take } from 'redux-saga/effects';
import { clearMessage, ERROR, setMessage } from '../../containers/FormMessage/actions';
import LiveScores from '../../utils/livescore';
import parseUrl from '../../utils/parseUrl';
import { EVENT_IN_PLAY_CHANGE } from '../pds/actions';
import {
  connected,
  CONNECTION_ERROR,
  connectionError,
  connectionWarning,
  UPDATE_SUBSCRIPTIONS,
  updateCards,
  updateGoals,
  updatePeriod,
  updateScore,
  updateStats,
  updateTime
} from './actions';
import liveScoreChannel from './channels';

export function* watchLiveScoreChanges(livescore) {
  const channel = yield call(liveScoreChannel, livescore);

  try {
    while (true) {
      const data = yield take(channel);
      switch (data.type) {
        case 'connect':
        case 'reconnect': {
          yield put(connected());
          yield put(clearMessage('live_events'));
          break;
        }
        case 'connect_warning': {
          yield put(connectionWarning(data.reason));
          yield put(setMessage(
            ERROR,
            'Connection lost for live events. Trying to reconnect...',
            null,
            true,
            'live_events'
          ));
          break;
        }
        case 'connect_error':
        case 'disconnect': {
          yield put(connectionError(data.reason));
          yield put(setMessage(
            ERROR,
            'Connection lost for live events. Trying to reconnect...',
            null,
            true,
            'live_events'
          ));
          break;
        }
        case 'score': {
          yield put(updateScore(data.eventId, {
            scoreHome: data.scoreA,
            scoreAway: data.scoreB,
            scoreLabel: data.scoreLabel,
            subScoreHome: data.subScoreA,
            subScoreAway: data.subScoreB,
            subScoreLabel: data.subScoreLabel
          }));
          break;
        }
        case 'clock':
        case 'time': {
          yield put(updateTime(data.eventId, data.time));
          break;
        }
        case 'currentPeriod': {
          yield put(updatePeriod(data.eventId, data.period));
          break;
        }
        case 'cards': {
          yield put(updateCards(data.eventId, data.cards));
          break;
        }
        case 'goals': {
          yield put(updateGoals(data.eventId, data.goals));
          break;
        }
        case 'stats': {
          const { total } = data;
          yield put(updateStats(data.eventId, { total }));
          break;
        }
        default: {
          break;
        }
      }
    }
  } finally {
    if (yield cancelled()) {
      channel.close();
    }
  }
}

export function* watchInPlayChanges(liveEventsSelector) {
  const livescore = new LiveScores();
  const newUrl = parseUrl(api_config.new_livescore_api);
  const newOptions = {
    host: newUrl.host,
    port: newUrl.port,
    path: newUrl.path,
    secure: newUrl.secure,
    properties: { src: 'retail-plus' },
  };
  yield fork(watchLiveScoreChanges, livescore);

  try {
    let alreadyConnected = false;
    let lastAction;
    while (true) {
      const events = yield select(liveEventsSelector);
      if (events && events.length > 0) {
        alreadyConnected = true;
        yield livescore.connect(newOptions);
        yield livescore.updateSubscribtions(events);
      } else if (alreadyConnected && lastAction.type !== UPDATE_SUBSCRIPTIONS) {
        yield livescore.disconnect();
        alreadyConnected = false;
      }
      lastAction = yield take([EVENT_IN_PLAY_CHANGE, CONNECTION_ERROR, UPDATE_SUBSCRIPTIONS]);
    }
  } finally {
    yield livescore.disconnect();
  }
}

export default watchInPlayChanges;
